import type { LoremCorpus, LoremSourceLoader } from "../types";

// Classical Latin source — small Cicero-derived sample for It2.T01.
// T02 expands this to the full ~250-sentence corpus per Engineering
// brief §C6 (~12KB bundle target).

const SENTENCES: readonly string[] = [
	"Lorem ipsum dolor sit amet, consectetur adipiscing elit",
	"Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
	"Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat",
	"Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur",
	"Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum",
	"Curabitur pretium tincidunt lacus",
	"Nulla gravida orci a odio",
	"Nullam varius, turpis et commodo pharetra, est eros bibendum elit, nec luctus magna felis sollicitudin mauris",
	"Integer in mauris eu nibh euismod gravida",
	"Duis ac tellus et risus vulputate vehicula",
	"Donec lobortis risus a elit",
	"Etiam tempor",
	"Ut ullamcorper, ligula eu tempor congue, eros est euismod turpis, id tincidunt sapien risus a quam",
	"Maecenas fermentum consequat mi",
	"Donec fermentum",
	"Pellentesque malesuada nulla a mi",
	"Duis sapien sem, aliquet nec, commodo eget, consequat quis, neque",
	"Aliquam faucibus, elit ut dictum aliquet, felis nisl adipiscing sapien, sed malesuada diam lacus eget erat",
	"Cras mollis scelerisque nunc",
	"Nullam arcu",
	"Aliquam consequat",
	"Curabitur augue lorem, dapibus quis, laoreet et, pretium ac, nisi",
	"Aenean magna nisl, mollis quis, molestie eu, feugiat in, orci",
	"In hac habitasse platea dictumst",
	"Fusce convallis, mauris imperdiet gravida bibendum, nisl turpis suscipit mauris, sed placerat ipsum urna sed risus",
	"In convallis tellus a mauris",
	"Curabitur non elit ac leo fringilla congue",
	"Sed dictum, sapien at vehicula tincidunt, nisl ipsum eleifend dui, vel hendrerit nisl massa eu nibh",
	"Cras et erat eu ipsum convallis pharetra",
	"Donec lobortis tristique massa",
	"Ut a est nec lectus blandit volutpat",
	"Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas",
	"Vivamus venenatis lectus eu nibh suscipit, eget gravida ipsum dignissim",
	"Mauris faucibus, neque a sodales luctus, leo arcu pulvinar enim, in tristique mauris ipsum vitae nibh",
	"Quisque facilisis fermentum sapien id molestie",
	"Praesent vel ligula nec elit faucibus pulvinar",
	"Aliquam erat volutpat",
	"Nam in justo a libero feugiat congue",
	"Phasellus suscipit, mauris ac vehicula laoreet, urna eros bibendum est, eget pulvinar arcu nibh non purus",
	"Vestibulum vitae justo et lectus posuere viverra",
];

export const loadLoremClassical: LoremSourceLoader =
	async (): Promise<LoremCorpus> => ({
		name: "lorem",
		displayName: "Classical Latin (Cicero)",
		sentences: [...SENTENCES],
	});
